import { Component } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'dont-forget-to-smile-control',
    templateUrl: 'dont-forget-to-smile.control.html',
    styleUrl: './dont-forget-to-smile.control.scss',
    standalone: false,
})
export class DontForgetToSmileControl extends ControlBase {}
